// import { qs } from '../qs'
import curd from '../curd'

const BASE_PATH = '/aqi/pollution-characteristic'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/Characteristic.js